import React, {useEffect, useMemo, useState} from 'react'
import DropDown from "../../DropDown";
import ColorItemPicker from "./components/ColorItemPicker";
import {ColorI} from "../../../types";
import styles from './index.module.scss'

const colorPickerList: ColorI[] = [
    {
        id: 1,
        color: "#FF5B5D",
    },
    {
        id: 2,
        color: "#00B884",
    },
    {
        id: 3,
        color: "#45BEFF",
    },
    {
        id: 4,
        color: "#53CFDC",
    },
    {
        id: 5,
        color: "#61C658",
    },
    {
        id: 6,
        color: "#718FFF",
    },
    {
        id: 7,
        color: "#8466FF",
    },
    {
        id: 8,
        color: "#EC5FFF",
    },
    {
        id: 9,
        color: "#FF6CC7",
    },
    {
        id: 10,
        color: "#FFC145",
    },
]

interface ColorPickerProps {
    getColor: (color: string) => void
    currentColor: string
    isOpen?: boolean
    setIsOpen?: (isOpen: boolean) => void
}

export default function ColorPicker({getColor, currentColor, isOpen, setIsOpen}: ColorPickerProps) {
    const [localIsOpen, setLocalIsOpen] = useState(false)
    const open = isOpen ?? localIsOpen

    const handleSetIsOpen = (nextIsOpen: boolean) => {
        setLocalIsOpen(nextIsOpen)
        setIsOpen?.(nextIsOpen)
    }

    useEffect(() => {
        if (typeof isOpen === 'boolean') {
            setLocalIsOpen(isOpen)
        }
    }, [isOpen])

    const btn = useMemo(() => {
        return (
            <div className={`${styles.colorPicker} ${open && styles.open}`}>
                <div className={styles.colorPicker__square}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M14 6H6V14H14V6ZM6 0C2.68629 0 0 2.68629 0 6V14C0 17.3137 2.68629 20 6 20H14C17.3137 20 20 17.3137 20 14V6C20 2.68629 17.3137 0 14 0H6Z" fill={currentColor}/>
                    </svg>
                </div>
                <img className={styles.colorPicker__arrow} src="/icon/arrow.svg" alt="arrow"/>
            </div>
        )
    }, [currentColor, open])

    return (
        <DropDown
            isOpen={open}
            setIsOpen={handleSetIsOpen}
            btn={btn}
            contentClassName={styles.colorPicker__dropdownContent}>
            <div>
                <div className={styles.colorPicker__container_title}>
                    Выбор цвета
                </div>
                <div className={styles.colorPicker__container}>
                    {colorPickerList.map( color =>  (
                        <ColorItemPicker key={color.id} currentColor={color.color} getColor={getColor} isActive={currentColor === color.color}/>
                    ))}
                </div>
            </div>
        </DropDown>
    )
}
